const allProductsPage = () => import('@/views/product/all-products/index.vue')
const defaultLayout = () => import('@/layout/default.vue')

const allProductRoutes = [
  {
    path: '/all-products',
    component: defaultLayout,
    children: [
      {
        path: '',
        name: 'All Products',
        component: allProductsPage,
        meta: {
          cnName: '全部商品',
          enName: 'Products'
        }
      }
    ]
  },
  {
    path: '/en/all-products',
    component: defaultLayout,
    children: [
      {
        path: '',
        name: 'allProductsEn',
        component: allProductsPage,
        meta: {
          cnName: '全部商品',
          enName: 'Products'
        }
      }
    ]
  }
]

export default allProductRoutes
